<template>
  <div class="popup-container" :style="styleContainer" v-click-outside="close">
    <div style="position: relative">
      <div ref="arrow" class="popup-arrow"></div>
    </div>

    <div v-show="visible" ref="popup" class="popup" :style="style">
      <slot ref="slot"/>
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  export default {
    computed: {
      currentChild() {
        return this.$refs.popup.firstChild
      },
      getVelocity() {
        if (this.withAnimation === 'slow')
          return 50
        else if (this.withAnimation === 'medium')
          return 25
        else
          return 5
      },
      style() {
        return {
          height: this.heightPopup + 'px',
          width: this.width + 'px',
        }
      },
      styleContainer() {
        return {
          left: '-' + Math.abs(this.width / 2 - this.left) + 'px'
        }
      }
    },
    data() {
      return {
        currentHeight: 0,
        heightPopup: 0,
        left: 0,
        opened: false,
        visible: false,
        widthPopup: 0
      }
    },
    directives: { ClickOutside },
    methods: {
      animation(positive) {
        const interval = setInterval(() => {
          let size = this.heightPopup || 0
          size = (positive ? size + 10 : size - 10)
          this.heightPopup = size

          if (positive && this.heightPopup > this.realHeight()) {
            this.finishOpen()
            clearInterval(interval)
          } else if (!positive && this.heightPopup < 0) {
            this.finishClose()
            clearInterval(interval)
          }
        }, this.getVelocity)
      },
      close() {
        if (this.opened && this.value)
          this.$emit('input', false)
        else if (this.opened)
          this.startClose()
      },
      finishClose() {
        this.$refs.arrow.style.display = 'none'
        this.heightPopup = 0
        this.opened = false
        this.visible = false
        this.$emit('closePopup')

        this.$refs.arrow.style.display = 'none'
      },
      finishOpen() {
        this.$nextTick(() => {
          this.$emit('openPopup')
          this.heightPopup = this.realHeight()
          setTimeout(() => this.opened = true, 100)
        })
      },
      realHeight() {
        const el = this.currentChild
        const style = window.getComputedStyle(el)
        return el.offsetHeight +
          (parseInt(style.marginTop) || 0) +
          (parseInt(style.marginBottom) || 0)
      },
      startClose() {
        this.$emit('startClosePopup')
        this.heightPopup = this.realHeight()

        if (this.withAnimation)
          this.animation()
        else
          this.finishClose()
      },
      startOpen() {
        this.$emit('startOpenPopup')
        this.$refs.arrow.style.display = ''
        this.heightPopup = 0
        this.visible = true

        if (this.withAnimation)
          this.animation(true)
        else
          this.finishOpen()
      }
    },
    mounted() {
      this.popupItem = this.$el
      const popup = this.$refs.popup
      this.$refs.arrow.style.display = 'none'

      if (this.startWith === null)
        this.left = popup.parentElement.parentElement.offsetWidth / 2
      else
        this.left = this.startWith
    },
    name: 'Popup',
    props: {
      startWith: { default: null, type: [Number, null] },
      value: { required: true, type: Boolean },
      width: { default: 200, type: Number },
      withAnimation: { default: null, type: [String, null] },
    },
    watch: {
      value(value) {
        if (value && !this.opened)
          this.startOpen()
        else if (!value && this.opened && this.visible)
          this.startClose()
      }
    }
  }
</script>

<style scoped>
  .popup-container {
    position: absolute;
    top: 50px;
  }
  .popup {
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.23);
    border-radius: 8px;
    background: var(--white-bg);
    overflow-y: hidden;
    overflow-x: auto;
    padding: 0;
  }

  .popup-arrow {
    position: absolute;
    left: calc(50% - 20px);
    top: -20px;
    width: 0;
    height: 0;
    border-width: 0 20px 20px 20px;
    border-color: transparent transparent var(--white-bg) transparent;
    border-style: solid;
  }

</style>
